(function($){

    // Mobile menu
    var $menu = $('#mainMenu');
    var $menuTrigger = $('#trigger');
    var $menuTriggerContainer = $('#triggerContainer');

    function openMobileMenu() {
        $('html').addClass('menu-open');
        $('body').addClass('disable');
        $menuTrigger.addClass('open');
        $menuTriggerContainer.attr('aria-expanded', 'true');
        $menu.addClass('is-open').attr('aria-hidden', 'false');
        $('#siteLogo, #header__contact-button').addClass('reposition');
    }

    function closeMobileMenu() {
        $('html').removeClass('menu-open');
        $('body').removeClass('disable');
        $menuTrigger.removeClass('open');
        $menuTriggerContainer.attr('aria-expanded', 'false');
        $menu.removeClass('is-open').attr('aria-hidden', 'true');
        $('#siteLogo, #header__contact-button').removeClass('reposition');
    }

    $menuTriggerContainer
        .attr({
            'aria-controls': 'mainMenu',
            'aria-expanded': 'false',
            'aria-label': 'Toggle navigation menu',
            'role': 'button',
            'tabindex': '0'
        })
        .on('click', function () {
            if ($menu.hasClass('is-open')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        })
        .on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                $(this).trigger('click');
            }
        });

    if (window.innerWidth <= 1024) {
        $menu.attr('aria-hidden', 'true');
    }

    $('#mainMenu a').on('click', function () {
        if ($('#trigger').hasClass('open')) {
            closeMobileMenu();
        }
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $menu.hasClass('is-open')) {
            closeMobileMenu();
            $menuTriggerContainer.trigger('focus');
        }
    });

    $(window).on('resize.menu orientationchange.menu', function () {
        if (window.innerWidth > 1024) {
            if ($menu.hasClass('is-open')) {
                closeMobileMenu();
            }

            $menu.removeAttr('aria-hidden');
        } else {
            $menu.attr('aria-hidden', String(!$menu.hasClass('is-open')));
        }
    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });


    // Initiate aos animations
	AOS.init();


    // Remove empty paragraphs
    $('p:empty:not([role])').remove();


    var isSide = $('#installer-popout').css('right') == '-222px';
        var isBottom = $('#installer-popout').css('bottom') == '-228px';
        var isSideOpen = false;

        if(isSide){
            $('#installer-popout').addClass('side-placement');
        } else if (isBottom) {
            $('#installer-popout').addClass('bottom-placement');
        }


        $('#installer-popout.side-placement').on('mouseover', function(e){
            if(!isSideOpen) {
                $('#installer-popout').animate({'right': '0px'}, 200, function(){
                    $('i', this).removeClass('fa-caret-up').addClass('fa-caret-down');
                }).clearQueue();
                isSideOpen = true;
            }
        });

        $('#installer-popout.side-placement').on('mouseout', function(e){
            if(isSideOpen) {
                $('#installer-popout').animate({'right': '-222px'}, 200, function(){
                    $('i', this).removeClass('fa-caret-down').addClass('fa-caret-up');
                }).clearQueue();
                isSideOpen = false;
            }
        });


        $('#installer-popout.bottom-placement').on('click', function(e){
            if($('#installer-popout').css('bottom') == '-228px') {
                $('#installer-popout').animate({'bottom': '0px'}, 200, function(){
                    $('i', this).removeClass('fa-caret-up').addClass('fa-caret-down');
                }).clearQueue();
            } else {
                $('#installer-popout').animate({'bottom': '-228px'}, 200, function(){
                    $('i', this).removeClass('fa-caret-up').addClass('fa-caret-up');
                }).clearQueue();
            }
            
        });
        

})(jQuery);
